enum TeledataStatusType {
  GREEN = 1,
  YELLOW = 2,
  RED = 3,
  // INITIAL = 3,
}

export default TeledataStatusType
